const contentElementRoutingPattern = /^\/?learningObject\/([^/]+)$/;
function extractElementIdFromPath(path) {
  var _a;
  return (_a = path.match(contentElementRoutingPattern)) == null ? void 0 : _a[1];
}

export { extractElementIdFromPath };
//# sourceMappingURL=util.get-element-id-from-path.js.map
